<template>
    <header>
        <router-link to="/" class="logo">
            <rich-logo />
            <h2 class="uni-body">Rich'en danse</h2>
        </router-link>
        <nav class="container">
            <menu-link to="/"
                       label="Danseurs"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                </svg>
            </menu-link>
            <menu-link to="/paiements"
                       label="Paiements"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>
                </svg>
            </menu-link>
        </nav>
        <menu-link to="/mon-compte"
                        label="Mon compte">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"/>
            </svg>
        </menu-link>
    </header>
</template>

<script>
    import MenuLink from "../a-elements/MenuLink";
    import RichLogo from "../a-elements/RichLogo";
    export default {
        name: "RichClientHeader",
        components: {RichLogo, MenuLink}
    }
</script>

<style scoped lang="scss">
header{
    display:flex;
    justify-content: space-between;
    height: 48px;
    align-items: center;
    padding: 16px;
    position:fixed;
    width: 100%;
    top:0;
    left:0;
    background: white;
    z-index: 10;
}
    nav{
        display: none;
    }
    h2, /deep/ a{
        white-space: nowrap;
    }

    .logo{
        display: flex;
        align-items: center;
    }

    @include screen-xs{
        header{
            padding: 16px;
        }
    }

    @include screen-m{
        header{
            height: 72px;
            border-bottom: 1px solid var(--color-grey-light-2);
            padding: 24px;
        }
        nav{
            display:block;
            width: 100%;
            padding: 0 32px;
            /deep/ a{
                margin-right: 32px;
            }
        }
    }
</style>
